var invalidProps = new Set(['isNotificationShown', 'active', 'flexShrink', 'flexItem', 'flexDirection', 'alignItems', 'justifyContent', 'isError', 'paddingX', 'paddingY', 'boxShadow', 'borderRadius', 'leftIcon']);
/**
 * This implements the default behavior from styled-components v5
 * Filter out props that are not valid for the target DOM elements.
 * See: https://styled-components.com/docs/faqs#shouldforwardprop-is-no-longer-provided-by-default
 */
export var shouldForwardProp = function shouldForwardProp(propName, target) {
    if (typeof target === 'string') {
        // For HTML elements, forward the prop if it is a valid HTML attribute
        return !invalidProps.has(propName);
    }
    // For other elements, forward all props
    return true;
};
